import { S3_BUCKET_URL } from 'src/constants';
import { ICsvImageData, IImageItem } from 'src/models/UploadImages';
import { parseDatasetName } from 'src/utils/datasetUtils';


  const parseCSV = (csvText: string): ICsvImageData[] => {
    const lines = csvText.split('\n');
    const headers = lines[0].split(',');
  
    return lines.slice(1).map((line) => {
      const values = line.split(',');
      return headers.reduce((obj, header, index) => {
        obj[header.trim()] = values[index];
        return obj;
      }, {} as ICsvImageData);
    });
  };
  

  const fetchCSVData = async (csvUrl: string): Promise<ICsvImageData[]> => {
    try {
      const response = await fetch(csvUrl);
      const csvText = await response.text();
      return parseCSV(csvText);
    } catch (error) {
      throw error;
    }
  };

export const processImages = async (isJob : boolean , jobData : any , jobDetails : any, images : IImageItem[], jobId : string, datasetId : string, isExistingDataset : boolean, isDataFetched : boolean) => {
    let newImages:IImageItem[] = [];
    if (!isExistingDataset && isJob && isDataFetched) {
      let extractedJobIdentifier = jobId;
      
      const parsedName = parseDatasetName(jobId);
      if (parsedName && parsedName.isJobBased && parsedName.jobId) {
        extractedJobIdentifier = parsedName.jobId;
      } else if (jobId.includes('dataset_jobId_')) {
        extractedJobIdentifier = jobId.replace('dataset_jobId_', '');
      }
      
      const csvUrl = `${S3_BUCKET_URL()}/output/${extractedJobIdentifier}/indiGrainLabelsIndiGrains.csv`;
      try {
        console.log('Attempting to fetch CSV from:', csvUrl);
        const csvData = await fetchCSVData(csvUrl);
        newImages = await processImageData(csvData, jobId, true);
        console.log('Successfully processed CSV data, found images:', newImages.length);
      } catch (error) {
        console.warn('Failed to fetch CSV data, falling back to job/dataset data:', error);
        const fallbackImages = images || 
                               jobDetails?.images || 
                               jobDetails?.Items || 
                               jobData?.images || 
                               jobData?.results?.images ||
                               [];
        
        console.log('Fallback images found:', fallbackImages.length);
        
        if (fallbackImages.length > 0) {
          newImages = await processImageData(fallbackImages, jobId);
          console.log('Successfully processed fallback images:', newImages.length);
        } else {
          throw new Error('No images available for this job. The CSV file could not be loaded and no fallback image data was found. This might be because the job is still processing or the data is not accessible.');
        }
      }
    } else if (isExistingDataset && isJob) {
      newImages = await processImageData(images, jobId);
    } else if (!isJob) {
      newImages = await processImageData(images, datasetId);
    }

    newImages.sort((a, b) => {
      const pathA = a.imagePath || '';
      const pathB = b.imagePath || '';
      return pathA.localeCompare(pathB, undefined, { numeric: true, sensitivity: 'base' });
    });

    return newImages;
};

const processImageData = async (sourceImages: ICsvImageData[] | IImageItem[], sourceId: string, isCSVData = false) => {
  return Promise.all(
    sourceImages
      .filter((img) => {
        const imagePath = isCSVData ? img.ImagePath : (img.imagePath || img.ImagePath);
        return imagePath && imagePath.trim() !== '';
      })
      .map(async (img) => {
        const imagePath = isCSVData ? img.ImagePath : (img.imagePath || img.ImagePath);
        const label = isCSVData ? (img.label || 'Good Grains') : (img.label || 'Good Grains');
        return {
          imagePath: imagePath,
          label: label,
          imageUrl: isCSVData
            ? `${S3_BUCKET_URL()}/${img.ImagePath}`
            : img.imageUrl ||
              `${S3_BUCKET_URL()}/${img.imagePath || img.ImagePath}`,
        };
      })
  );
};

